import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { Box, Button, useTheme } from '@mui/material';
import { BoxImg, FormControlDefault } from 'app/shared/layout/register/DefaultFormsComponents';
import React, { ChangeEvent } from 'react';
import { ValidatedBlobField, openFile } from 'react-jhipster';
import { NoImage } from '../no-image/NoImage';
export const ImageInput = ({ image, imageContentType, handleInputChange }) => {
  const theme = useTheme();
  const isImage = !(image === null || image === undefined || image === '');

  const cleanImage = () => {
    handleInputChange('image', null);
  };

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result as string;
        resolve(base64String.split(',')[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleFileInputChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      try {
        const base64String = await fileToBase64(file);
        handleInputChange('image', base64String);
      } catch (error) {
        console.error('Error converting file to base64:', error);
      }
    }
  };
  return (
    <FormControlDefault sx={{ width: '300px', heigth: '450px', margin: '0 auto' }}>
      <Box position="relative" width="100%" height="100%">
        {isImage ? (
          <>
            <Box component={'a'} width={'100%'} onClick={openFile('image/jpeg', image)}>
              <BoxImg src={`data:${imageContentType};base64,${image}`} alt="imagem-implemento" />
            </Box>
            <Box position="absolute" top={0} right={'5px'}>
              <Button variant="contained" sx={{ minWidth: '14px', padding: '4px 8px', width: '32px', borderRadius: '32px', color: 'error' }}>
                <ClearOutlinedIcon onClick={cleanImage} />
              </Button>
            </Box>
          </>
        ) : (
          <Box sx={{ border: `1px dashed gray`, borderRadius: '8px' }}>
            <NoImage />
          </Box>
        )}
        <Box
          component={'span'}
          sx={{
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            right: 5,
            bottom: 5,
            width: '46px',
            height: '46px',
            borderRadius: '36px',
            boxShadow: ' 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
            padding: '4px 8px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <ValidatedBlobField
            style={{ cursor: 'pointer', width: '20px', top: '0px' }}
            id="icon-button-file"
            name={'image'}
            onChange={handleFileInputChange}
            data-cy="image"
            isImage
            type="file"
            accept="image/*"
            className="image-field"
          />
          <AddAPhotoOutlinedIcon fontSize="medium" sx={{ color: theme.palette.text.primary, position: 'absolute', top: '10px' }} />
        </Box>
      </Box>
    </FormControlDefault>
  );
};
